import type { TaskTrackerColumnSortOrder } from '../../lib/taskTrackerColumnSort.utils'
import { TASK_TRACKER_COLUMN_SORT_POSITION_VALUE } from '../../lib/taskTrackerColumnSort.constants'

export type TaskTrackerColumnSortState = {
  sortField: string
  sortOrder: TaskTrackerColumnSortOrder
  reloading: boolean
  isExpanded: boolean
}

export type ColumnSortBoardState = Record<number, TaskTrackerColumnSortState>

export type ColumnSortSliceState = Record<number, ColumnSortBoardState>

export const createInitialColumnSortState = (): TaskTrackerColumnSortState => ({
  sortField: TASK_TRACKER_COLUMN_SORT_POSITION_VALUE,
  sortOrder: 'asc',
  reloading: false,
  isExpanded: false,
})
